import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Tag as TagIcon } from "lucide-react";

export default function Tags() {
  const [tags, setTags] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/tags").then(r => setTags(r.data));
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-[#E11D48] font-bold mb-2">Signals</p>
        <h1 className="font-display text-4xl font-bold tracking-tighter">Tags</h1>
        <p className="text-slate-400 text-sm mt-2">Click any tag to filter your library.</p>
      </div>

      {tags.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-white/10 rounded-2xl" data-testid="tags-empty">
          <TagIcon className="w-10 h-10 mx-auto text-slate-600 mb-4" />
          <p className="text-slate-400">No tags yet — add tags when creating a movie.</p>
        </div>
      ) : (
        <div className="flex flex-wrap gap-2" data-testid="tags-cloud">
          {tags.map(t => (
            <button
              key={t}
              onClick={() => nav(`/dashboard?tag=${encodeURIComponent(t)}`)}
              data-testid={`tag-${t}`}
              className="px-4 py-2 rounded-full bg-[#0F0F12] border border-white/10 text-sm hover:border-[#E11D48] hover:text-[#E11D48] transition-all"
            >
              #{t}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
